// TODO: Move this into utility package
/**
 * Groups items by a key and returns a record with non-empty arrays of items for each key.
 * @param items Array of items to group
 * @param getKey Function to extract the key from an item
 * @returns Record with non-empty arrays of items grouped by key
 */
export function groupBy(items, getKey) {
    const result = {};
    for (const item of items) {
        const key = getKey(item);
        if (!Object.prototype.hasOwnProperty.call(result, key)) {
            Object.defineProperty(result, key, {
                value: [item],
                configurable: true,
                enumerable: true,
                writable: true,
            });
        }
        else {
            result[key].push(item);
        }
    }
    return result;
}
//# sourceMappingURL=groupBy.js.map